/* MARCA | 15/05/2026 | New file – Variant-reactive custom element for the low stock indicator block */

import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

class LowStockIndicator extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.handleVariantUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.handleVariantUpdate);
  }

  handleVariantUpdate = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    const newIndicator = event.detail.data.html.querySelector('low-stock-indicator');

    if (!newIndicator) return;

    const wasHidden = this.hasAttribute('hidden');
    const willHide = newIndicator.hasAttribute('hidden');

    morph(this, newIndicator, { childrenOnly: true });

    if (willHide) {
      this.setAttribute('hidden', '');
    } else {
      this.removeAttribute('hidden');
    }
  };
}

if (!customElements.get('low-stock-indicator')) {
  customElements.define('low-stock-indicator', LowStockIndicator);
}
